module.exports = __webpack_public_path__ + "img/tarj3-2.4edff4f4.svg";